import axios from "axios";
import { environment } from "../../../environment";
const url = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/custodian-doc/documents/client`
        : `https://middleware.uat.farther.com/custodian-doc/documents/client`;
};
export default async function postUploadDocument(path, file, config) {
    const formData = new FormData();
    // WARNING "fisier" MUST come before path or only 13 bytes of the file will be uploaded
    formData.set("fisier", file); // MUST BE THE FIRST FIELD IN THE FORM
    formData.set("path", path);
    await axios.postForm(url(), formData, {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
}
//# sourceMappingURL=postUploadDocument.js.map